import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import _ from 'lodash';

import ContentView from 'components/content';
import ContentSelection from 'components/contentSelection';
import Widgets from 'components/widgets';
import AdvancedSettings from 'components/settings';
import NDAList from 'components/nda/index';
import StarterPlanIntegrations from 'components/starterPlanIntegrations';
import StarterLicencePlanIntegrations from 'components/starterLicencePlanIntegrations';

import { Button } from 'react-bootstrap';

import CollectionWidgetManager from 'services/collections.widget.service';
import { attachContent, closeModal } from 'services/messages.service';
import { generateLinkRequest } from 'actions/links';

import styles from './integration.module.scss';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';

const widgetManager = new CollectionWidgetManager();

export default function IntegrationView(props) {
  const dispatch = useDispatch();

  const [attaching, setAttaching] = useState(false);

  const applicationContext = useSelector(state => _.get(state, `application`));
  const integration = useSelector(state => _.get(state, `application.integration.id`));
  const assets = useSelector(state => _.get(state, `application.assets`, []));
  const source = useSelector(state => _.get(state, `application.type`, null));
  const collection = useSelector(state => _.get(state, `application.collection`, null));
  const empty = collection == null && assets.length == 0;
  const [showNDAList, setShowNDAList] = useState(false);
  const [nda, setNda] = useState(null);
  const [sourceCrm, setSourceCrm] = useState(null);
  const subscriptionPlan = useSelector((state) => _.get(state, 'users.account.item.subscription.subscriptionPlan.key')) || "";
  const userPlan = useSelector((state) => _.get(state,'users.profile.item.userRoles[0].key')) || "";

  useEffect(() => {
    if(source === "hubspot" || source === "salesforce"){
      setSourceCrm(source);
    }
  },[source])

  const handleAttachContent = () => {
    setAttaching(true);

    const request = {
      ...(applicationContext.settings || {}),
      integration: integration,
      link: applicationContext.linkId
    };

    if (collection) {
      request['collection'] = collection;
    } else if (assets.length > 0) {
      request['assets'] = assets;
    }

    dispatch(generateLinkRequest(request, (response) => {
      const html = widgetManager.widget(response.widget).render(response);

      var context = {
        ...response,
        html: html
      }
      attachContent(context);
    }));
  }

  const handleNDAClick = () => {
    if(nda != null) {
      setNda(null);
    } else {
      setShowNDAList(!showNDAList);
    }
  }

  const handleNdaSelection = (nda) => {
    setNda(nda);
    setShowNDAList(!showNDAList);
  }

  const handleNDAChange = () => {
    setShowNDAList(!showNDAList);
  }


  if (subscriptionPlan === "starter") {
    return <StarterPlanIntegrations />;
}
if (userPlan === "starter_licence") {
    return <StarterLicencePlanIntegrations />;
}

  return (
    <div className={styles.container}>
      <div className={styles.left}>
        <ContentView source={source}/>
      </div>
      <div className={styles.right}>
        <div className={styles.inner}>
          {!showNDAList && 
            <>
              <ContentSelection />
              {!empty &&
                <>
                  <Widgets filter={props.filterWidgets} />
                  <AdvancedSettings onNDAToggle={handleNDAClick} nda={nda} source={sourceCrm} onNDAChange={handleNDAChange}/>

                  <div className={styles.actions}>
                    <Button variant='link' onClick={() => closeModal(applicationContext.id)} disabled={attaching}>Cancel</Button>
                    <Button variant='link' className={styles.attach} onClick={handleAttachContent} disabled={attaching}>
                      {attaching ? 'Attaching...' : 'Attach'}
                    </Button>
                  </div>
                </>
              }
            </>
          }
          {showNDAList &&
            <div className={styles.backButton}>
              <Button variant='link' onClick={() => setShowNDAList(!showNDAList)}>
                <FontAwesomeIcon icon={faChevronLeft} size="sm" /> NDA Templates
              </Button>
              <NDAList onNDASelection={(nda) => handleNdaSelection(nda)}/>
            </div>
          }
        </div>
      </div>
    </div>
  )
}